<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import Swal from "sweetalert2";
import ExtensionActivity from "@/router/views/planning/extension-activity.vue";
import AttachmentModal from "@/components/modals/attachment-modal.vue";

export default {
    page: {
        title: "Programs",
    },
    components: {
        Layout,
        PageHeader,
        DatePicker,
        ExtensionActivity,
        AttachmentModal
    },
    data() {
        return {
            title: "Extension Programs",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Extension Programs",
                    active: true,
                },
            ],
            tableData: [],
            form: {
                id: 0,
                extensionName: "",
                dateFrom: "",
                dateTo: "",
                programId: 0,
            },
            filterExt: "",
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 20, 30, 40, 50],
            fields: [
                {
                    key: "program.programName",
                    sortable: true,
                    label: "Program",
                },
                {
                    key: "extensionName",
                    sortable: true,
                },
                {
                    key: "dateFromDisplay",
                    sortable: true,
                    label: "Date From",
                },
                {
                    key: "dateToDisplay",
                    sortable: true,
                    label: "Date To",
                },
                {
                    key: "actions",
                },
            ],
            sortBy: "",
            sortDesc: false,
            tableBusy: false,
            modalTitle: "",
            campuses: [],
            selectedCampus: "",
            programLoading: false,
            filterCampus: "",
            campusSelection: false,
            programSelection: false,
            programs: [],
            selectedProgram: [],
            filterProgram: "",
            showExtAct: false,
            activeOption: 1,
            search: {
                dateFrom: new Date(new Date().getFullYear() - 1 + "-01-01"),
                dateTo: new Date(),
            },
            uploadTitle: "",
        };
    },
    validations: {
        form: {
            extensionName: { required },
            dateFrom: { required },
            dateTo: { required },
        },
        search: {
            dateFrom: { required },
            dateTo: { required },
        }
        
    },
    computed: {
        filteredExtensions() {
            let data = this.tableData;
            if (this.filterExt.trim() != "" && this.filterExt) {
                data = data.filter((item) => {
                    return item.filterItem
                        .toUpperCase()
                        .includes(this.filterExt.toUpperCase());
                });
            }
            return data;
        },
        rows() {
            if (this.filterExt.trim() != "" && this.filterExt) {
                return this.filteredExtensions.length;
            } else {
                return this.tableData.length;
            }
        },
        filteredCampus() {
            let data = this.campuses;
            if (this.filterCampus.trim() != "" && this.filterCampus) {
                data = data.filter((item) => {
                    return item.campusName
                        .toUpperCase()
                        .includes(this.filterCampus.toUpperCase());
                });
            }
            return data;
        },
        filteredDU() {
            let data = this.programs;
            if (this.filterProgram.trim() != "" && this.filterProgram) {
                data = data.filter((item) => {
                    return item.name
                        .toUpperCase()
                        .includes(this.filterProgram.toUpperCase());
                });
            }
            return data;
        },
    },
    created() {
        this.getPending();
        this.$store.state.decrypt.campusAccessList().forEach((campus) => {
            this.campuses.push({
                id: campus.Id,
                campusName: campus.CampusName,
            });
        });
    },
    methods: {
        onCreateExt() {
            this.submitted = true;
            this.$v.form.$touch();
            var data = cloneDeep(this.form);
            data.dateFrom = this.getDate(this.form.dateFrom);
            data.dateTo = this.getDate(this.form.dateTo);
            data.programId = this.form.id;
            if (this.$v.form.$invalid) {
                return;
            } else {
                if (this.form.id > 0) {
                    this.$store
                        .dispatch(
                            "extensionprogram/UpdateExtensionProgram",
                            data
                        )
                        .then((res) => {
                            res.data.fromDisplay = this.formatDate(
                                this.form.dateFrom
                            );
                            res.data.toDisplay = this.formatDate(
                                this.form.dateTo
                            );
                            res.data.addDocu = false;
                            res.data.documentData = data.documentData;
                            this.tableData.splice(
                                this.formensionIndex,
                                1,
                                res.data
                            );
                            this.$bvModal.hide("extension-modal");
                            this.showToast("Successfully updated!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                } else {
                    this.$store
                        .dispatch(
                            "extensionprogram/CreateExtensionProgram",
                            data
                        )
                        .then((res) => {
                            res.data.fromDisplay = this.formatDate(
                                this.form.dateFrom
                            );
                            res.data.toDisplay = this.formatDate(
                                this.form.dateTo
                            );
                            res.data.openAttachment = false;
                            res.data.addDocu = false;
                            res.data.documentData = [];
                            this.tableData.push(res.data);
                            this.$bvModal.hide("extension-modal");
                            this.showToast("Successfully created!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
                this.submitted = false;
            }
        },
        onResetExt() {
            this.form = {
                id: 0,
                extensionName: "",
                dateFrom: "",
                dateTo: "",
                programId: 0,
            };
        },
        addEP() {
            this.onResetExt();
            this.modalTitle = "Create New Extension Program";
            this.$bvModal.show("extension-modal");
        },
        updateItem(props) {
            this.form = cloneDeep(props);
            this.form.dateFrom = new Date(props.dateFrom);
            this.form.dateTo = new Date(props.dateTo);
            this.formensionIndex = this.tableData.indexOf(props);
            this.modalTitle = "Update Extension Program";
            this.$bvModal.show("extension-modal");
        },
        deleteItem(props) {
            var index = this.tableData.indexOf(props);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.value) {
                    await this.$store
                        .dispatch(
                            "extensionprogram/DeleteExtensionProgram",
                            props.id
                        )
                        .then((res) => {
                            if (res.status == 204) {
                                this.tableData.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        openCampusSelection() {
            this.campusSelection = true;
            this.openCampus = true;
        },
        closeCampus() {
            if (this.campusSelection) {
                this.campusSelection = false;
            }
            this.openCampus = false;
        },
        selectCampus(row) {
            this.campusSelection = false;
            this.selectedCampus = row.campusName;
            this.getPrograms(row.id);
        },
        getPrograms(id) {
            this.programs = [];
            this.$store
                .dispatch("program/GetProgramByCampus", id)
                .then((res) => {
                    this.programs = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        openProgramSelection() {
            this.programSelection = true;
            this.openProgram = true;
        },
        closeProgram() {
            if (this.programSelection) {
                this.programSelection = false;
            }
            this.openProgram = false;
        },
        selectProgram(row) {
            this.selectedProgram.push(row);
            this.programs.splice(this.programs.indexOf(row), 1);
            this.filterProgram = "";
        },
        removeProgram(index) {
            this.programs.push(this.selectedProgram[index]);
            this.selectedProgram.splice(index, 1);
        },
        viewExtAct(x) {
            this.showExtAct = true;
            this.$nextTick(() => {
                this.$refs.extAct.getData(x);
                document.body.classList.add("extension-open");
            });
        },
        closeExtAct() {
            document.body.classList.remove("extension-open");
            this.showExtAct = false;
        },
        async getPending() {
            this.activeOption = 1;
            this.tableBusy = true;
            this.tableData = [];
            await this.$store
                .dispatch("extensionprogram/GetPendingExtensionProgram", this.$store.state.data.selectedCampus.id)
                .then((res) => {
                    res.data.forEach((item) => {
                        item.addDocu = false;
                        item.openAttachment = false;
                        item.attachmentLoading = false;
                        item.documentData = [];
                        item.rotateChevy = false;
                        item.filterItem = `${item.name}`;
                        item.programs.forEach((x) => {
                            item.filterItem += ` ${x.programName}`;
                            x.filterItem = `${x.programName}`;
                            x.extensionPrograms.forEach((y) => {
                                item.filterItem += ` ${y.extensionName}`;
                                x.filterItem += ` ${y.extensionName}`;
                            });
                        });
                    });
                    this.tableData = res.data;
                    this.extensionLoading = false;
                })
                .catch((err) => {
                    this.extensionLoading = false;
                    this.showToast("Something went wrong!", "error");
                });
            this.tableBusy = false;
        },
        async getApproved(currentDate) {
            this.activeOption = 2;
            this.submitted = true;
            let dateFrom = new Date().getFullYear() - 1 + "-01-01";
            let data = { 
                dateFrom: currentDate ? this.getDate(new Date(dateFrom)) : this.getDate(this.search.dateFrom),
                dateTo: currentDate ? this.getDate(new Date()) : this.getDate(this.search.dateTo),
            };
            data.campusId = this.$store.state.data.selectedCampus.id;
            this.$v.search.$touch();
            if (this.$v.search.$invalid) {
                return;
            }
            await this.$store
                .dispatch("extensionprogram/GetApprovedExtensionProgram", data)
                .then((res) => {
                    res.data.forEach((item) => {
                        item.addDocu = false;
                        item.openAttachment = false;
                        item.attachmentLoading = false;
                        item.documentData = [];
                        item.rotateChevy = false;
                        item.filterItem = `${item.name}`;
                        item.programs.forEach((x) => {
                            item.filterItem += ` ${x.programName}`;
                            x.filterItem = `${x.programName}`;
                            x.extensionPrograms.forEach((y) => {
                                item.filterItem += ` ${y.extensionName}`;
                                x.filterItem += ` ${y.extensionName}`;
                            });
                        });
                    });
                    this.tableData = res.data;
                    this.extensionLoading = false;
                })
                .catch((err) => {
                    this.extensionLoading = false;
                    this.showToast("Something went wrong!", "error");
                });
            this.submitted = false;
            this.tableBusy = false;
        },
        filterPrograms(row) {
            let data = row;
            if (this.filterExt.trim() != "" && this.filterExt) {
                data = data.filter((x) => {
                    return x.filterItem
                        .toUpperCase()
                        .includes(this.filterExt.toUpperCase());
                });
            }
            return data;
        },
        filterExtensions(row) {
            let data = row;
            if (this.filterExt.trim() != "" && this.filterExt) {
                data = data.filter((x) => {
                    return x.extensionName
                        .toUpperCase()
                        .includes(this.filterExt.toUpperCase());
                });
            }
            return data;
        },
        approveProgram(row, parent) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to approve this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, approve it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "extensionprogram/ApproveExtensionProgram",
                            row.id
                        )
                        .then((res) => {
                            this.showToast("Successfully approved!", "success");
                            parent.extensionPrograms.splice(parent.extensionPrograms.indexOf(row), 1);
                            if(parent.extensionPrograms.length == 0){
                                this.tableData.splice(this.tableData.indexOf(parent), 1);
                            }
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        viewFiles(row){
            this.uploadTitle = `Extension Program Attachments`;
            this.$refs.attachmentModal.setUploadOpt({
                type: "Extention Program",
                placement: "lefttop",
                folder: "Planning",
            });
            this.$refs.attachmentModal.getData(row.id);
            this.$bvModal.show("upload-attachment-modal");
        }
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="extension-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreateExt"
                class="needs-validation"
                ref="extForm"
            >
                <div
                    class="
                        text-center
                        cursor-pointer
                        py-3
                        px-2
                        br-5
                        border-dashed-img
                    "
                    @click="openCampusSelection"
                    v-if="!campusSelection"
                    :class="{
                        error: !selectedCampus && submitted,
                    }"
                >
                    <h5 class="mb-0 text-muted" v-if="!selectedCampus">
                        Click to Select {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}
                    </h5>
                    <h5 v-if="selectedCampus" class="mb-0">
                        {{ selectedCampus }}
                    </h5>
                </div>
                <div
                    class="
                        text-center
                        py-3
                        br-5
                        border-dashed-img
                        position-relative
                    "
                    v-if="campusSelection"
                    v-click-outside="closeCampus"
                >
                    <input
                        ref="campusInput"
                        v-model="filterCampus"
                        type="text"
                        class="custom-inline-form w-100 text-center"
                        :placeholder="`Search ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`"
                        @click="openCampus = true"
                    />
                    <div
                        class="selection-wrapper position-absolute w-100"
                        v-if="openCampus"
                    >
                        <ul class="multiselect__content text-left">
                            <template v-if="campuses.length == 0">
                                <li>
                                    <span class="multiselect__option"
                                        >No data found</span
                                    >
                                </li>
                            </template>
                            <template
                                v-if="
                                    campuses.length > 0 &&
                                    filteredCampus.length == 0
                                "
                            >
                                <li>
                                    <span class="multiselect__option"
                                        >Search not found</span
                                    >
                                </li>
                            </template>
                            <li
                                class="multiselect__element"
                                v-for="x in filteredCampus"
                                :key="x.id"
                                @click="selectCampus(x)"
                            >
                                <span class="multiselect__option">{{
                                    x.campusName
                                }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-if="programLoading">
                    <div class="d-flex justify-content-center m-3">
                        <i class="bx bx-loader font-size-30"></i>
                    </div>
                </div>
                <div v-if="selectedCampus && !programLoading">
                    <div class="d-flex justify-content-center m-3">
                        <i class="bx bx-down-arrow-alt font-size-30"></i>
                    </div>
                    <div
                        class="
                            cursor-pointer
                            py-3
                            px-2
                            br-5
                            border-dashed-img
                            position-relative
                        "
                        :class="{
                            error: selectedProgram.length == 0 && submitted,
                        }"
                        style="min-height: 50px"
                        v-if="!programSelection"
                    >
                        <div
                            class="
                                position-absolute
                                w-100
                                d-flex
                                align-items-center
                                justify-content-center
                            "
                            style="top: 0; left: 0; bottom: 0; right: 0"
                            @click="openProgramSelection"
                        >
                            <h5
                                class="mb-0 text-muted text-center"
                                v-if="selectedProgram.length == 0"
                            >
                                Click to Select Delivery Units
                            </h5>
                        </div>
                        <div
                            class="w-100"
                            style="
                                top: 10px;
                                left: 10px;
                                bottom: 10px;
                                right: 10px;
                            "
                            v-if="selectedProgram.length > 0"
                        >
                            <div class="multiselect__tags-wrap">
                                <span
                                    class="multiselect__tag"
                                    v-for="(program, index) in selectedProgram"
                                    :key="program.id"
                                >
                                    <span>{{ program.programName }}</span>
                                    <i
                                        class="multiselect__tag-icon"
                                        @click="removeProgram(index)"
                                    ></i
                                ></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="py-3 br-5 border-dashed-img position-relative"
                    v-if="programSelection"
                    v-click-outside="closeProgram"
                >
                    <div class="px-2">
                        <div class="multiselect__tags-wrap">
                            <span
                                class="multiselect__tag"
                                v-for="(du, index) in selectedProgram"
                                :key="du.id"
                            >
                                <span>{{ du.name }}</span>
                                <i
                                    class="multiselect__tag-icon"
                                    @click="removeProgram(index)"
                                ></i
                            ></span>
                        </div>
                    </div>
                    <input
                        ref="duInput"
                        type="text"
                        class="custom-inline-form w-100 text-center"
                        placeholder="Search Delivery Unit"
                        @click="openProgram = true"
                        v-model="filterProgram"
                    />
                    <div
                        class="selection-wrapper position-absolute w-100"
                        v-if="openProgram"
                    >
                        <ul class="multiselect__content text-left">
                            <template v-if="programs.length == 0">
                                <li>
                                    <span class="multiselect__option"
                                        >No data found</span
                                    >
                                </li>
                            </template>
                            <template
                                v-if="
                                    programs.length > 0 &&
                                    filteredDU.length == 0
                                "
                            >
                                <li>
                                    <span class="multiselect__option"
                                        >Search not found</span
                                    >
                                </li>
                            </template>
                            <li
                                class="multiselect__element"
                                v-for="x in filteredDU"
                                :key="x.id"
                                @click="selectDU(x)"
                            >
                                <span class="multiselect__option">{{
                                    x.name
                                }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="extensionName">Extension Name </label>
                    <input
                        autocomplete="off"
                        id="extensionName"
                        type="text"
                        v-model="form.extensionName"
                        placeholder="Enter Extension Name..."
                        class="form-control"
                        :class="{
                            'is-invalid':
                                submitted && $v.form.extensionName.$error,
                        }"
                    />
                    <div
                        v-if="submitted && $v.form.extensionName.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.extensionName.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <label for="boardResNo">Date From </label>
                    <date-picker
                        v-model="form.dateFrom"
                        :first-day-of-week="1"
                        lang="en"
                        placeholder="Enter Date From..."
                        :class="{
                            'is-invalid': submitted && $v.form.dateFrom.$error,
                        }"
                    ></date-picker>
                    <div
                        v-if="submitted && $v.form.dateFrom.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.dateFrom.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="mb-3">
                    <label for="boardResNo">Date To </label>
                    <date-picker
                        v-model="form.dateTo"
                        :first-day-of-week="1"
                        lang="en"
                        placeholder="Enter Date To..."
                        :class="{
                            'is-invalid': submitted && $v.form.dateTo.$error,
                        }"
                    ></date-picker>
                    <div
                        v-if="submitted && $v.form.dateTo.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.dateTo.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('extension-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div
                            class="
                                d-flex
                                justify-content-between
                                align-items-center
                                mb-3
                            "
                        >
                            <div>
                                <h4 class="card-title m-0">
                                    Extension Program List
                                </h4>
                            </div>
                            <div class="d-flex align-items-center" v-if="activeOption == 2">
                                From
                                <div class="mx-2">
                                    <date-picker
                                        v-model="search.dateFrom"
                                        :first-day-of-week="1"
                                        lang="en"
                                        placeholder="Enter Date From..."
                                        :class="{
                                            'is-invalid': submitted && $v.search.dateFrom.$error,
                                        }"
                                    ></date-picker>
                                    <div
                                        v-if="submitted && $v.search.dateFrom.$error"
                                        class="invalid-feedback"
                                    >
                                        <span v-if="!$v.search.dateFrom.required"
                                            >This value is required.</span
                                        >
                                    </div>
                                </div>
                                to
                                <div class="mx-2">
                                    <date-picker
                                        v-model="search.dateTo"
                                        :first-day-of-week="1"
                                        lang="en"
                                        placeholder="Enter Date To..."
                                        :class="{
                                            'is-invalid': submitted && $v.search.dateTo.$error,
                                        }"
                                    >
                                    </date-picker>
                                    <div
                                        v-if="submitted && $v.search.dateTo.$error"
                                        class="invalid-feedback"
                                    >
                                        <span v-if="!$v.search.dateTo.required"
                                            >This value is required.</span
                                        >
                                    </div>
                                </div>
                                <button class="btn btn-light" type="button" @click="getApproved(false)">
                                    <i class="fas fa-search"></i>
                                </button>
                                <!-- <button
                                    type="button"
                                    @click="addEP()"
                                    class="
                                        btn btn-md btn-info
                                        d-flex
                                        align-items-center
                                    "
                                >
                                    <i class="bx bx-plus fs-6"></i>Create New
                                </button> -->
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <button
                                    class="btn rounded-pill me-2"
                                    :class="{
                                        'btn-light': activeOption != 1,
                                        'btn-warning': activeOption == 1,
                                    }"
                                    type="button"
                                    @click="getPending"
                                >
                                    <span class="px-3">Pending</span>
                                </button>
                                <button
                                    class="btn rounded-pill"
                                    :class="{
                                        'btn-light': activeOption != 2,
                                        'btn-success': activeOption == 2,
                                    }"
                                    type="button"
                                    @click="getApproved(true)"
                                >
                                    <span class="px-3">Approved</span>
                                </button>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-end"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Search:
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filterExt"
                                            type="search"
                                            placeholder="Search..."
                                            class="
                                                form-control form-control-sm
                                                ms-2
                                            "
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <div class="mt-3">
                            <h5>
                                List of
                                {{ activeOption == 1 ? "Pending" : "Approved" }}
                                Extension Program by Delivery Unit
                            </h5>
                            <div v-if="tableData.length == 0">
                                <h5 class="text-warning">No data found</h5>
                            </div>
                            <div v-else>
                                <ul>
                                    <li
                                        v-for="x in filteredExtensions"
                                        :key="x.id"
                                        class="w-100 mb-2"
                                    >
                                        <div
                                            class="
                                                d-flex
                                                align-items-center
                                                justify-content-between
                                            "
                                        >
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                "
                                            >
                                                <a
                                                    href="javascript:void(0);"
                                                    class="
                                                        font-size-18
                                                        text-dark
                                                    "
                                                    @click="
                                                        x.rotateChevy =
                                                            !x.rotateChevy
                                                    "
                                                    >{{ x.name }}
                                                    <i
                                                        class="
                                                            bx bx-caret-right
                                                            rotate
                                                        "
                                                        :class="{
                                                            'rotate-90':
                                                                x.rotateChevy,
                                                        }"
                                                    ></i
                                                ></a>
                                            </div>
                                        </div>
                                        <b-collapse :visible="x.rotateChevy">
                                            <div
                                                class="card mx-3 my-2"
                                                v-for="y in filterPrograms(
                                                    x.programs
                                                )"
                                                :key="`target-${x.id}-${y.id}`"
                                            >
                                                <div class="card-body">
                                                    <h5 class="text-success">
                                                        {{ y.programName }}
                                                    </h5>
                                                    <ul>
                                                        <li
                                                            v-for="w in filterExtensions(
                                                                y.extensionPrograms
                                                            )"
                                                            :key="`ext-${x.id}-${y.id}-${w.id}`"
                                                            class="mb-2"
                                                        >
                                                            <div
                                                                class="
                                                                    d-flex
                                                                    justify-content-between
                                                                "
                                                            >
                                                                <div>
                                                                    <div>
                                                                        <p
                                                                            class="
                                                                                font-size-16
                                                                                mb-0
                                                                            "
                                                                        >
                                                                            {{
                                                                                w.extensionName
                                                                            }}
                                                                        </p>
                                                                    </div>
                                                                    <div
                                                                        class="
                                                                            d-flex
                                                                        "
                                                                    >
                                                                        <div
                                                                            class="
                                                                                d-flex
                                                                                align-items-center
                                                                            "
                                                                        >
                                                                            <i
                                                                                class="
                                                                                    bx
                                                                                    bx-calendar
                                                                                "
                                                                            ></i>
                                                                            <span
                                                                                class="
                                                                                    ms-2
                                                                                "
                                                                                >From
                                                                                {{
                                                                                    formatDate(
                                                                                        new Date(
                                                                                            w.dateFrom
                                                                                        )
                                                                                    )
                                                                                }}
                                                                                to
                                                                                {{
                                                                                    formatDate(
                                                                                        new Date(
                                                                                            w.dateTo
                                                                                        )
                                                                                    )
                                                                                }}</span
                                                                            >
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <button
                                                                        class="
                                                                            btn
                                                                            btn-sm
                                                                            btn-purple
                                                                            me-2
                                                                        "
                                                                        type="button"
                                                                        @click="
                                                                            viewFiles(w)
                                                                        "
                                                                    >
                                                                        <i
                                                                            class="
                                                                                bx
                                                                                bx-file
                                                                            "
                                                                        ></i>
                                                                        View Files
                                                                    </button>
                                                                    <button
                                                                        class="
                                                                            btn
                                                                            btn-sm
                                                                            btn-success
                                                                            me-2
                                                                        "
                                                                        v-if="activeOption == 1"
                                                                        type="button"
                                                                        @click="
                                                                            approveProgram(
                                                                                w,
                                                                                y
                                                                            )
                                                                        "
                                                                    >
                                                                        <i
                                                                            class="
                                                                                bx
                                                                                bx-check
                                                                            "
                                                                        ></i>
                                                                        Approve
                                                                        Program
                                                                    </button>
                                                                    <button
                                                                        class="
                                                                            btn
                                                                            btn-sm
                                                                            btn-primary
                                                                        "
                                                                        type="button"
                                                                        @click="
                                                                            viewExtAct(
                                                                                w
                                                                            )
                                                                        "
                                                                        v-if="activeOption == 2"
                                                                    >
                                                                        <i
                                                                            class="
                                                                                bx
                                                                                bx-list-ol
                                                                            "
                                                                        ></i>
                                                                        View
                                                                        Activities
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </b-collapse>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <extension-activity
            ref="extAct"
            @close="closeExtAct"
            v-if="showExtAct"
            :allowAdd="false"
        ></extension-activity>
        <attachment-modal
            :wActions="false"
            :title="uploadTitle"
            ref="attachmentModal"
        ></attachment-modal>
    </Layout>
</template>